import { render, staticRenderFns } from "./store-create-success.vue?vue&type=template&id=452198e6&scoped=true"
import script from "./store-create-success.vue?vue&type=script&lang=ts"
export * from "./store-create-success.vue?vue&type=script&lang=ts"
import style0 from "./store-create-success.vue?vue&type=style&index=0&id=452198e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452198e6",
  null
  
)

export default component.exports